module.exports = __webpack_public_path__ + "static/talkspace_logo-ecfd4897807f0c507cc69df0b66fdb37.png";